import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { useUserData } from "../../../auth/useUserData.js";
import {
  BreadcrumbItem,
  PageTopbarItem,
} from "../../../commons/layout/Page.js";
import { ManagePropertiesTable } from "../../../features/item-properties/ManagePropertiesTable.js";
import { useTemplateQuotePropertiesQuery } from "./TemplateQuoteProperties.generated.js";

interface Props {
  docId: string;
  submenuItems: PageTopbarItem[];
  prefixBreadcrumbs: BreadcrumbItem[];
  pathToDocList: string;
  pageSubHeader: React.ReactElement | null;
}

export function TemplateQuoteProperties({
  docId,
  submenuItems,
  prefixBreadcrumbs,
  pathToDocList,
  pageSubHeader,
}: Props) {
  const { t } = useTranslate(["Global", "QuoteItem"]);
  const viewer = useUserData().currentUser!;
  const client = useApolloClient();
  const query = useTemplateQuotePropertiesQuery({
    client,
    variables: { docId },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
  const quoteTemplate = getDataOrNull(
    query.data?.quoteTemplateLatest
  )?.quoteTemplate;

  return !query.loading && quoteTemplate ? (
    <ManagePropertiesTable
      docType="TEMPLATE"
      documentViewerPermissions={viewer.organisationPermissions}
      items={quoteTemplate.items}
      templateTypeProperties={
        quoteTemplate?.implementsTemplateType?.templateType.props2
      }
      projectId={null}
      docId={docId}
      pageProps={{
        title: quoteTemplate?.title ?? "",
        subtitle: t("Manage properties", { ns: "QuoteItem" }),
        submenuItems: submenuItems,
        breadcrumbs: prefixBreadcrumbs,
        subHeader: pageSubHeader,
        headerType: "template",
      }}
    />
  ) : null;
}
